import { n as e, t } from "./createApiQueryClient-DwmsEdyU.js";
import { t as n } from "./v20240509-JTkMfURM.js";
import { t as r } from "./v20240730-DFhmpDyF.js";
import { t as i } from "./v99990101-BzXA787k.js";
import { canadianProvinces as a, countriesAlpha2 as o, countriesAlpha2Emojis as s, getStateOptions as c, isRegionState as l, statesForCountry as u, statesWithNamesForCountry as d, toCountryLabel as f, toStateLabel as p, usStates as m } from "./utils/commonEnums/index.js";
import { CUSTOMER_ADDRESS_PURPOSES as h, getBillingAddress as g, toBillingOnlyAddresses as _ } from "./utils/commonModels/index.js";
import { _ as v, a as y, b, c as x, d as S, f as C, g as w, h as T, i as E, l as D, m as O, n as k, o as A, p as j, r as M, s as N, t as P, u as F, v as I, y as L } from "./utils-CjmxQ-9r.js";
import { QueryClientProvider as R } from "@tanstack/react-query";
import { PersistQueryClientProvider as z } from "@tanstack/react-query-persist-client";
import { jsx as B } from "react/jsx-runtime";
import { ReactQueryDevtools as V, ReactQueryDevtoolsPanel as H } from "@tanstack/react-query-devtools/production";
//#region src/apiQueryProvider.tsx
var U = typeof process < "u" ? "Wed Nov 04 2026 15:53:35 GMT+0000 (Coordinated Universal Time)" : void 0, W = ({ client: t, persister: n, maxAge: r = e, children: i }) => n ? /* @__PURE__ */ B(z, {
	client: t,
	persistOptions: {
		persister: n,
		maxAge: r,
		buster: U,
		dehydrateOptions: {
			shouldDehydrateMutation: () => !1,
			shouldDehydrateQuery: (e) => e.queryKey.includes("persist") && !e.queryKey.includes("legacy") && e.state.status === "success"
		}
	},
	children: i
}) : /* @__PURE__ */ B(R, {
	client: t,
	children: i
}), G = V, K = H, q = {
	dashboard20240730Client: r,
	dashboardv20240509Client: n,
	dashboardv99990101Client: i
};
//#endregion
export { G as ApiQueryDevtools, K as ApiQueryDevtoolsPanel, W as ApiQueryProvider, h as CUSTOMER_ADDRESS_PURPOSES, x as baseUseMutation, D as baseUseQuery, a as canadianProvinces, q as clients, o as countriesAlpha2, s as countriesAlpha2Emojis, t as createApiQueryClient, M as createApiQueryPersister, F as ensureQueryData, P as extractValidationErrors, S as fetchQuery, g as getBillingAddress, c as getStateOptions, I as isQuickBooksErrorResponse, l as isRegionState, L as isSequenceApiError, b as isSequenceApiErrorResponse, u as statesForCountry, d as statesWithNamesForCountry, _ as toBillingOnlyAddresses, f as toCountryLabel, p as toStateLabel, m as usStates, C as useApiQueryClient, j as useComplexQuery, O as useInfiniteQuery, E as useLoadAllItems, k as useLoadAllItemsQuery, A as useMockMutation, N as useMockQuery, T as useMutation, w as useQuery, v as useRunInvalidationForMutation, y as useSequenceInfiniteQuery };

//# sourceMappingURL=index.js.map